import React, { Fragment, useState } from "react";
import { Card } from "antd";
import { tabList } from "./tabList";
import { useGetTableCodigos } from "../../../Hooks/Admin";

export const Codigos = () => {
  const [activeTabKey, setActiveTabKey] = useState("codigos-pokemon");
  const formularioHook = useGetTableCodigos({ key: activeTabKey });

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };

  return (
    <Fragment>
      <Card
        style={{
          width: "100%",
        }}
        tabList={tabList}
        activeTabKey={activeTabKey}
        onTabChange={onTabChange}
        tabProps={{
          size: "small",
        }}
      >
        {activeTabKey && formularioHook}
      </Card>
    </Fragment>
  );
};
